import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dashboard" }
const _hoisted_2 = { class: "column left" }
const _hoisted_3 = { class: "below-video" }
const _hoisted_4 = { class: "column right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DashboardAbout = _resolveComponent("DashboardAbout")!
  const _component_DashboardVideo = _resolveComponent("DashboardVideo")!
  const _component_DashboardOrbit = _resolveComponent("DashboardOrbit")!
  const _component_DashboardSystems = _resolveComponent("DashboardSystems")!
  const _component_DashboardComms = _resolveComponent("DashboardComms")!
  const _component_DashboardTransmitters = _resolveComponent("DashboardTransmitters")!
  const _component_DashboardHosting = _resolveComponent("DashboardHosting")!
  const _component_DashboardPublicAddress = _resolveComponent("DashboardPublicAddress")!
  const _component_DashboardArrivals = _resolveComponent("DashboardArrivals")!
  const _component_DashboardDepartures = _resolveComponent("DashboardDepartures")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_DashboardAbout),
      _createVNode(_component_DashboardVideo),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createVNode(_component_DashboardOrbit),
          _createVNode(_component_DashboardSystems)
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_DashboardComms),
          _createVNode(_component_DashboardTransmitters),
          _createVNode(_component_DashboardHosting),
          _createVNode(_component_DashboardPublicAddress)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_DashboardArrivals),
      _createVNode(_component_DashboardDepartures)
    ])
  ]))
}